export function PatientResultItemSkeleton() {
  return (
    <div className="flex w-full items-center gap-3 px-5 py-2">
      {/* Avatar */}
      <div className="size-8 shrink-0 animate-pulse rounded-[10px] bg-[#E5E7EB]" />

      <div className="flex flex-1 flex-col gap-px">
        <div className="flex h-5 items-center">
          <div className="h-3 w-36 animate-pulse rounded-full bg-[#E5E7EB]" />
        </div>
        <div className="flex h-4 items-center gap-2">
          <div className="h-2.5 w-16 animate-pulse rounded-full bg-[#F3F4F6]" />
          <div className="h-2.5 w-24 animate-pulse rounded-full bg-[#F3F4F6]" />
          <div className="h-2.5 w-20 animate-pulse rounded-full bg-[#F3F4F6]" />
        </div>
      </div>
      <div className="h-[25px] w-16 shrink-0 animate-pulse rounded-full bg-[#E5E7EB]" />
    </div>
  );
}
